import { createElement, memo, useState } from '@max/max';
import { createStore } from 'redux';
import { ReactReduxContext, useProvider } from '@max/max-redux';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import './index.scss';
import App from './pages/app';
import { reducer } from './store';
const MyComponent = (props) => {
    const ctx = useMonitorEngineContext();
    // const moduleId = ctx._moduleId;
    const [store] = useState(createStore(reducer)); // 给redux 用
    const storeValue = useProvider({
        store
    });
    const handleOnChange = (params) => {
        var _a;
        console.log('dynamicPoiListSearchParamsChanged event', params);
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.emit('dynamicPoiListSearchParamsChanged', params);
    };
    const handleOnCityChange = (cityInfo) => {
        var _a;
        console.log('handleOnCityChange event', cityInfo);
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.emit('cityChanged', cityInfo);
    };
    return <ReactReduxContext.Provider value={storeValue}>
      <App {...props} onChange={handleOnChange} handleOnCityChange={handleOnCityChange}/>
    </ReactReduxContext.Provider>;
};
export default memo(MyComponent);
